import { render, staticRenderFns } from "./addKeyWord.vue?vue&type=template&id=2d29e964&scoped=true"
import script from "./addKeyWord.vue?vue&type=script&lang=js"
export * from "./addKeyWord.vue?vue&type=script&lang=js"
import style0 from "./addKeyWord.vue?vue&type=style&index=0&id=2d29e964&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d29e964",
  null
  
)

export default component.exports